<template>
  <div id="top-wrap">
    <ul id="top-works" v-if='works.length > 0'>
      <h2>Works</h2>
      <li  v-for='(work, index) in works' :key='index'>
        <h3>{{ work.year }}</h3>
          <p v-for='(content, index) in work.contents' v-if='content.showTop' :key='index'>
            - {{ content.description }}<a v-if='content.link !== ""' :href="content.link" target='_blank' :alt='content.link'> >> Link </a>
          </p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "top-page",
  data() {
    return {
      works: [
        // {
        //   year: 2018,
        //   contents: [
        //     {
        //       showTop: false,
        //       description: "トップには載せていない実績"
        //     },
        //     {
        //       showTop: true,
        //       description: "トップに載せられる実績",
        //       link: "http://google.com"
        //     },
        //     {
        //       showTop: true,
        //       description:
        //         "トップに乗せても大丈夫な何故か改行しないと表示しきれない字数の文字列によって記述された実績",
        //       link: "http://google.com"
        //     }
        //   ]
        // },
        // {
        //   year: 2017,
        //   contents: [
        //     {
        //       showTop: true,
        //       description: "トップに実績",
        //       link: ""
        //     },
        //     {
        //       showTop: true,
        //       description: "犬神サーカス団",
        //       link: ""
        //     },
        //     {
        //       showTop: true,
        //       description: "コレジャナイロボ",
        //       link: ""
        //     }
        //   ]
        // }
      ]
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#top-wrap {
  width: 100%;
  height: 100%;
}

#top-wrap,
#top-works:before {
  background-image: url("../assets/bg_test.png");
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
}

#top-works {
  position: fixed;
  overflow-x: hidden;
  overflow-y: scroll;
  height: 300px;
  max-height: calc(50% - (50px + 1vh));
  max-width: 50%;
    bottom: calc(50px + 1vh);
  right: 0;
}

#top-works:before {
  content: "";
  z-index: -2;
  filter: brightness(0.25) blur(5px);
  position: fixed;
  width: 100%;
  height: 100%;

  margin: 0;
  padding: 0;
}

#top-works ul {
  list-style-type: none;
  height: 100%;
  padding: 0 1em;
}
#top-works ul h3 {
  border-bottom: 1px solid white;
}
#top-works li {
  padding: 0 10px;
}

#top-works li p {
  display: block;
  word-wrap: break-word;
  margin: 1em;
}

#top-works li p a {
  margin-left: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/TopPage.vue